import React, { useEffect } from 'react';
import { Box, Button, Card, CardActions, CardHeader, LinearProgress, Paper, Skeleton } from '@mui/material';
import { DataGridPremium, GridToolbar } from '@mui/x-data-grid-premium';

import { RestitutionCards } from '../../../jsx/RestitutionCards';

const RestitutionView = (props) => {

    const {
        loading,
        mode,
        ts,
        updateRemitter,
        setUpdateRemitter,
        updateRestitution,
        setUpdateRestitution,
        state,
        restitutionColumns,
        setRestitutionModal,
        restitutionCreated,
        handleFieldChange,
        caseNumber,
        RetrieveRestitution,
        restitutionRows,
        HandleUpdateRestitution,
        handleTotalRestitutionFocus,
        handleMonthlyPaymentFocus,
        HandleUpdateRestitutionCards,
        paymentPlanModal,
        setPaymentPlanModal,
        setDeleteRestitutionModal
    } = props;

    useEffect(() => {
        if (restitutionRows && restitutionRows.length > 0) {
            handleFieldChange(
                'totalPaid',
                new Intl.NumberFormat('en-US',
                    {
                        style: 'currency',
                        currency: 'USD',
                        maximumFractionDigits: 2
                    })
                    .format(
                        restitutionRows?.reduce((acc, val) => {
                            acc += val.paymentAmount
                            return acc;
                        }, 0.00)
                    )
            )
        }
    }, [restitutionRows]);

    return (
        restitutionCreated
            ?
            <Box sx={{ width: '99%', height: '100%', mx: 'auto', px: 'auto', mt: '1vh' }}>
                <Paper elevation={10} sx={{ backGroundColor: 'transparent' }}>
                    <Paper className="border-radius-bottom" sx={{ backgroundColor: 'steelblue', color: 'white', height: 'auto', m: 'auto', p: '.5vh', display: 'flex' }}>
                        <h6 style={{ fontWeight: 'bold', fontSize: 'inherit', marginBottom: '0px' }}>Restitution</h6>
                    </Paper>
                    <RestitutionCards
                        mode={mode}
                        setUpdateRemitter={setUpdateRemitter}
                        setUpdateRestitution={setUpdateRestitution}
                        ts={ts}
                        updateRemitter={updateRemitter}
                        updateRestitution={updateRestitution}
                        state={state}
                        restitutionCreated={restitutionCreated}
                        handleFieldChange={handleFieldChange}
                        caseNumber={caseNumber}
                        RetrieveRestitution={RetrieveRestitution}
                        HandleUpdateRestitution={HandleUpdateRestitution}
                        handleTotalRestitutionFocus={handleTotalRestitutionFocus}
                        handleMonthlyPaymentFocus={handleMonthlyPaymentFocus}
                        HandleUpdateRestitutionCards={HandleUpdateRestitutionCards}
                        paymentPlanModal={paymentPlanModal}
                        setPaymentPlanModal={setPaymentPlanModal}
                        setDeleteRestitutionModal={setDeleteRestitutionModal}
                    />
                </Paper>
                <Box sx={{ marginTop: '2vh' }}>
                    <Paper elevation={10}>
                        <Paper className="border-radius-bottom" sx={{ backgroundColor: 'steelblue', color: 'white', height: 'auto', m: 'auto', p: '.5vh', display: 'flex' }}>
                            <h6 style={{ fontWeight: 'bold', fontSize: 'inherit', marginBottom: '0px' }}>Restitution Payment History</h6>
                        </Paper>
                        <Box sx={{ minHeight: '20vh' }}>
                            <DataGridPremium
                                rows={restitutionRows}
                                columns={restitutionColumns}
                                disableMultipleRowSelection
                                loading={false}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10
                                        }
                                    }
                                }}
                                slots={{
                                    toolbar: GridToolbar,
                                    loadingOverlay: LinearProgress
                                }}
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                        printOptions: { disableToolbarButton: true },
                                    },
                                }}
                                localeText={{ noRowsLabel: 'No Restitution Payments Made Yet' }}
                                rowHeight={50}
                                sx={{
                                    ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                                        marginTop: "1em",
                                        marginBottom: "1em"
                                    },
                                    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                                        outline: "none !important",
                                    }, "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus": {
                                        outline: "none !important",
                                    },
                                    maxHeight: '55vh',
                                }}
                            />
                        </Box>
                    </Paper>
                </Box>
            </Box >
            :
            <Box
                sx={
                    {
                        display: 'flex',
                        justifyContent: 'center',
                        mt: '1vh'
                    }
                }
            >
                <Card
                    sx={
                        {
                            background: mode === 'dark' ? "rgb(37, 37, 37)" : 'rgb(255,255,255)',
                            width: '21%',
                            height: 'auto',
                            alignItems: 'center',
                            slotProps: {
                                title: {
                                    m: 'auto',
                                    p: 'auto',
                                }
                            }
                        }
                    }
                    elevation={5}
                >
                    <CardHeader
                        title={
                            loading
                                ?
                                <Skeleton
                                    width={'50%'}
                                    height={"100%"}
                                    animation="wave" />
                                : "Create Restitution"
                        }
                        subheader={
                            loading
                                ?
                                <Skeleton
                                    width={'100%'}
                                    height={"100%"}
                                    animation="wave" />
                                : "Once Created, You Can Track The Progress Here"
                        }
                    />
                    <CardActions>
                        <Box
                            sx={{ display: 'flex', m: 'auto', p: 'auto' }}>
                            {
                                loading
                                    ?
                                    <Skeleton
                                        width='20vw'
                                        height="10vh"
                                        animation="wave"
                                    />
                                    :
                                    <Button
                                        variant="contained"
                                        sx={{ p: '.75rem', mt: '0', width: '20vw', maxWidth: '20vw', backgroundColor: 'steelblue', color: 'white', height: 'auto', fontSize: '1.25rem' }}
                                        onClick={() => setRestitutionModal(true)}
                                    >
                                        Create Restitution
                                    </Button>
                            }
                        </Box>
                    </CardActions>
                </Card>
            </Box>

    )
}
export default RestitutionView;
